export const text_colors = (dark) => ({
    primary: dark ? '#f0f0f0' : '#101010',
    secondary: dark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)',
    disabled: dark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)',
});
